import React, { useState, useEffect } from 'react';
import { Company } from '../types/models';
import { CompanyService } from '../services/companyService';
import { CompanyForm } from '../components/forms/CompanyForm';

export const CompaniesPage: React.FC = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [showForm, setShowForm] = useState(false);
  const [editingCompany, setEditingCompany] = useState<Company | null>(null);

  useEffect(() => {
    loadCompanies();
  }, []);

  const loadCompanies = async () => {
    try {
      setLoading(true);
      const response = await CompanyService.getUserCompanies();
      if (response.success) {
        setCompanies(response.data);
      } else {
        setError(response.message || 'Ошибка загрузки контрагентов');
      }
    } catch (err) {
      setError('Ошибка загрузки данных');
    } finally {
      setLoading(false);
    }
  };

  const handleCreate = () => {
    setEditingCompany(null);
    setShowForm(true);
  };

  const handleEdit = (company: Company) => {
    setEditingCompany(company);
    setShowForm(true);
  };

  const handleDelete = async (company: Company) => {
    if (window.confirm(`Вы уверены, что хотите удалить контрагента "${company.shortName}"?`)) {
      try {
        const response = await CompanyService.delete(company.id);
        if (response.success) {
          loadCompanies(); // Перезагрузить список
        } else {
          setError(response.message || 'Ошибка удаления');
        }
      } catch (err) {
        setError('Ошибка удаления компании');
      }
    }
  };

  const handleFormSuccess = () => {
    setShowForm(false);
    setEditingCompany(null);
    loadCompanies(); // Перезагрузить список
  };

  const handleFormCancel = () => {
    setShowForm(false);
    setEditingCompany(null);
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error">
        {error}
      </div>
    );
  }

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">Контрагенты</h1>
        <button className="btn btn-primary" onClick={handleCreate}>
          Добавить контрагента
        </button>
      </div>

      <div className="card">
        <table className="table">
          <thead>
            <tr>
              <th>ID</th>
              <th>Полное название</th>
              <th>Краткое название</th>
              <th>ИНН</th>
              <th>ОГРН</th>
              <th>Действия</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((company) => (
              <tr key={company.id}>
                <td>{company.id}</td>
                <td>{company.fullName}</td>
                <td>{company.shortName}</td>
                <td>{company.inn}</td>
                <td>{company.ogrn}</td>
                <td>
                  <button
                    className="btn btn-secondary"
                    style={{ marginRight: '5px' }}
                    onClick={() => handleEdit(company)}
                  >
                    Редактировать
                  </button>
                  <button
                    className="btn btn-danger"
                    onClick={() => handleDelete(company)}
                  >
                    Удалить
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && (
        <CompanyForm
          company={editingCompany || undefined}
          onSuccess={handleFormSuccess}
          onCancel={handleFormCancel}
        />
      )}
    </div>
  );
};
